import { Injectable } from '@angular/core';
import { FF } from '@ff/fancy_framework/lib/fancy_framework';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})

export class FFService {
  public ff: FF;
  public FF: FF;

  constructor(
    private http: HttpClient,
  ) {
    this.FF = FF;
    this.ff = new FF(undefined, {mime_type: 'diagnostic_detail/definition', diagnostic_detail: 'low'});
    // this.ff.ff_service.subscribe(
    //   message => true,
    //   [this.message_to_http_request],
    // );
  }

  // message_to_http_request(message) {
  //   if (message.header.to.indexOf('/local') >= 0) {
  //     message.payload.forEach(item => {
  //       this.http.post(message.header.to, item).pipe(
  //         // Do stuff??
  //       ).subscribe();
  //     });
  //   }
  // }
}
